/*储代码字典信息*/
const code ={
  state:{
    deptCode:'',
    deptCode2:''
  },
  mutations:{
    SET_CODE1:(state,data)=>{
      state.deptCode =data;
    },
    SET_CODE2:(state,data)=>{
      state.deptCode2 = data
    }
  },
  actions:{
    changeCode1({commit},data){
      commit('SET_CODE1',data)
    },
    changeCode2({commit},data){
      commit('SET_CODE2',data)
    },
  }
};
export default code
